import Device from "../atoms/Device";
import reloj from "../../images/plataforma/sw-home.png";
import mobile from "../../images/plataforma/mobile-home.png";
import web from "../../images/plataforma/desktop-home.png";
import red from "../../images/plataforma/ico-familiaamigos.svg";
import ec from "../../images/plataforma/ico-elliecenter.svg";
import salud from "../../images/plataforma/ico-sissalud.svg";
import "./Plataforma.css";

export const Plataforma = () => {
  return (
    <div id="plataforma" style={{ paddingBlock: "50px" }}>
      
      <div className="plataforma-container-titles">
        <h1>Una plataforma simple</h1>
        <sub>y diseñada especialmente para vos</sub>
      </div>

      <div className="plataforma-container">
        <Device
          image={reloj}
          title="App Ellie GO Watch"
          sub="instalada en tu Ellie Watch"
        />
        <Device
          image={mobile}
          title="App Ellie GO"
          sub="para descargar en tu celular"
        />
        <Device image={web} title="Portal Web" sub="www.ellie.care/login" />
      </div>

      <h1>Que te permite elegir a quién</h1>
      <sub>o a quiénes te van a ayudar</sub>

      <div className="plataforma-container">
        <Device
          image={red}
          title="Tu Familia y Amigos"
          sub="Podes setear tu propia red
          de ayuda de hasta 5
          integrantes: tu familia, tu
          vecino, o quien vos quieras!"
        />
        <Device
          image={ec}
          title="Ellie Center"
          sub="¿Necesitas ayuda?
          ¿Te caíste? No te preocupes, estamos con vos 24x7 con nuestro Ellie Center."
        />
        <Device
          image={salud}
          title="Sistema de Salud"
          sub="¿Tu prepaga u Obra Social ofrece el servicio de Teleasistencia? ¡Nos podemos integrar con ellos!"
        />
      </div>
    </div>
  );
};

export default Plataforma;
